import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden"; // Adjust import path if needed
import { Download, X } from "lucide-react";
import Image from "../components/Image";

const FullScreenQrImageModal = ({
  open,
  onOpenChange,
  image,
  onDownload,
  onClose,
  fallbackImage = "",
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg w-full h-auto p-0 bg-black/95 rounded-2xl shadow-2xl flex flex-col items-center justify-center relative overflow-visible fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        {/* Visually hidden title for a11y */}
        <DialogTitle>
          <VisuallyHidden>QR Code Fullscreen Modal</VisuallyHidden>
        </DialogTitle>
        {/* Action buttons - top right */}
        <div className="absolute top-4 right-4 flex gap-2 z-50">
          <Button
            variant="ghost"
            size="icon"
            aria-label="Download QR code"
            onClick={onDownload}
            className="rounded-full bg-white/30 hover:bg-white/50 text-black"
          >
            <Download className="w-5 h-5" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Close modal"
            onClick={onClose}
            className="rounded-full bg-white/30 hover:bg-white/50 text-black"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>
        {/* Context title - optional */}
        <div className="mt-10 mb-4 text-white text-lg font-semibold">
          Assigned QR Code
        </div>
        {/* QR image inside card */}
        <div
          className="bg-white rounded-xl shadow-lg p-4 flex items-center justify-center mx-auto"
          style={{ maxWidth: 340, maxHeight: 340 }}
        >
          <Image
            fileId={image?.gdriveId || image?.gdrive_id}
            alt="QR Code"
            className="object-contain w-72 h-72 max-w-full max-h-full"
            fallbackImage={fallbackImage}
          />
        </div>
        {/* Optional: description, guidance, etc. */}
        <div className="mt-4 mb-8 text-gray-300 text-sm text-center">
          Scan this code to access details or download it for your records.
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenQrImageModal;
